import React, { PureComponent, Component } from 'react'

import Dialog from '@material-ui/core/Dialog'
import TextField from '@material-ui/core/TextField'

import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button';
import SelectList from '../SelectList'
import { alertActions } from '../../actions/alert.actions';
import { getFirebase } from 'react-redux-firebase'
import { dockPadEntityMapToList } from '../../containers/DockPadFormTemplates';
import { getNewId } from '../../actions/home.actions';
import { LookaheadTag, LookaheadTagStatus } from '../../models/LookaheadTag';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { Trade } from '../../models/Trade';
import classNames from 'classnames';
import { ColumnType } from '../PhasePlan/Column';
import { Constraint, ConstraintStatus } from '../../models/Constraint';
import MaterialTable, { MTableToolbar } from 'material-table'
import EditIcon from '@material-ui/icons/Edit';

import moment, { Moment } from 'moment'
import { DatePicker } from "material-ui-pickers";
import { Chip, IconButton, MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import { PhaseTag } from '../../models/PhaseTag';
import { CommitmentEntry } from '../../actions/lookahead.actions';
import { Tag } from '../../models/Tag';
import { Variance } from '../../utils/Variance';


const _ = require('lodash')

interface Props {
  isVarianceLogDialogOpen: boolean,
  classes: ClassNameMap;
  closeDialogValue: () => Promise<void>;
  projectUsers: Record<string, any>;
  type: ColumnType;
  isConstraintLogDialogOpen: boolean;
  constraintList: Constraint[];
  phasePlanTags: Record<string, PhaseTag>;
  openConstraintDialog: (constraintId?: string) => void
  phaseTags: Record<string, PhaseTag>;
  lookaheadTags: Record<string, LookaheadTag>;
  pathName: string;
  commitmentLog: CommitmentEntry[],
  trades: Record<string, Trade>

}



class VarianceLogDialog extends Component<Props> {
  constructor(props: Props) {
    super(props)
  }

  shouldComponentUpdate(nextProps:Props) {

    if(nextProps.isVarianceLogDialogOpen !== this.props.isVarianceLogDialogOpen) {
      return true
    }
    if(!_.isEqual(nextProps.commitmentLog, this.props.commitmentLog)) {
      return true
    }

    return false
  }


  async closeDialog() {
    const { closeDialogValue } = this.props
    closeDialogValue()
  }

  renderTableContainer() {
    return (
      <div>
        {this.renderVarianceTable()}
      </div>
    );
  }

  getTags = () => {
    const { pathName, lookaheadTags, phaseTags } = this.props
    if (pathName === '/phasePlan') {
      return phaseTags
    }

    if (pathName === '/lookahead') {
      return lookaheadTags
    }

    return {}
  }

  renderTag = (rowData: Constraint) => {
    if (!!this.getTags() && !!this.getTags()[rowData.tagId]) {
      const tag = this.getTags()[rowData.tagId] as PhaseTag

      return tag.name
    }
  }

  renderIdentifyByData(rowData: Constraint) {
    const { projectUsers } = this.props;
    if (!rowData.identifyBy || !projectUsers[rowData.identifyBy]) {
      return ''
    }

    return `${projectUsers[rowData.identifyBy].first_name} ${projectUsers[rowData.identifyBy].last_name} - ${projectUsers[rowData.identifyBy].email}`
  }

  renderStatusData(rowData: Constraint) {
    const { classes } = this.props;

    if (rowData.status === ConstraintStatus.Todo) {
      return <Chip label="Todo" className={classNames(classes.issuesTableStatusNotDone)} />
    }

    if (rowData.status === ConstraintStatus.WorkingOn) {
      return <Chip label="Working On" className={classNames(classes.issuesTableStatusDone)} />
    }

    if (rowData.status === ConstraintStatus.Done) {
      return <Chip label="Done" className={classNames(classes.issuesTableStatusDone)} />
    }

    if (rowData.status === ConstraintStatus.DoneDone) {
      return <Chip label="Done Done" className={classNames(classes.issuesTableStatusDone)} />
    }

    return <Chip label="Error" className={classNames(classes.issuesTableStatusError)} />
  }

  renderAssignedTo = (rowData: Constraint) => {
    const { projectUsers } = this.props;
    if (!rowData.assignedTo || !projectUsers[rowData.assignedTo]) {
      return ''
    }

    return `${projectUsers[rowData.assignedTo].first_name} ${projectUsers[rowData.assignedTo].last_name} - ${projectUsers[rowData.assignedTo].email}`
  }

  renderName = (rowData: CommitmentEntry) => {
    const tagId = rowData.uid

    const tag = this.getTags()[tagId] as Tag | undefined

    if (!tag) {
      return
    }

    return tag.name
  }

  renderTrade = (rowData: CommitmentEntry) => {
    const { trades } = this.props
    const tagId = rowData.uid

    const tag = this.getTags()[tagId] as Tag | undefined

    if (!tag || !trades || !trades[tag.tradeId]) {
      return
    }

    const trade = trades[tag.tradeId]

    return (
      <MuiThemeProvider theme={theme =>
        createMuiTheme({
          ...theme,
          overrides: {
            MuiChip: {
              colorPrimary: {
                backgroundColor: trade.color
              }
            }
          }
        })
      }
      >
        <div style={{ marginLeft: 16 }}>
          <Chip color="primary" label={trade.name} />
        </div>
      </MuiThemeProvider>
    )
  }

  renderVariance = (rowData: CommitmentEntry) => {
    return Variance[rowData.variance]
  }

  renderVarianceTable() {

    const { commitmentLog } = this.props;

    return (
      <MaterialTable

        components={{
          Toolbar: props => (
            <div >
            </div>
          )
        }}
        columns={[
          {
            title: 'Name',
            render: (rowData: any) => {
              return this.renderName(rowData)
            },
            cellStyle: {
              backgroundColor: '#f9fcfd',
              padding: '4px 16px'
            },
            headerStyle: {
              padding: '4px 16px'
            }
          },
          {
            title: 'Trade',
            render: rowData => {
              return this.renderTrade(rowData)
            },
            cellStyle: {
              backgroundColor: '#f9fcfd',
              padding: '4px 16px'
            },
            headerStyle: {
              padding: '4px 16px'
            }
          },
          {
            title: 'Promise Date',
            field: 'originalDate',
            cellStyle: {
              backgroundColor: '#f9fcfd',
              padding: '4px 16px'
            },
            headerStyle: {
              padding: '4px 16px'
            }
          },
          {
            title: 'Completed Date',
            field: 'actualDate',
            cellStyle: {
              backgroundColor: '#f9fcfd',
              padding: '4px 16px'
            },
            headerStyle: {
              padding: '4px 16px'
            }
          },
          {
            title: 'Variance',
            render: rowData => {
              return this.renderVariance(rowData)
            },
            cellStyle: {
              backgroundColor: '#f9fcfd',
              padding: '4px 16px'
            },
            headerStyle: {
              padding: '4px 16px'
            }
          }
        ]}
        data={commitmentLog}
        title=""
        options={{
          pageSize: 10
        }}
      />
    );
  }

  render() {
    const { isVarianceLogDialogOpen, classes } = this.props;
    return (
      <Dialog
        maxWidth='sm'
        fullWidth={true}
        open={!!isVarianceLogDialogOpen}
        onBackdropClick={this.closeDialog}
      >
        <DialogContent>
          <div className={classNames(classes.DialogFormTitle, classes.DialogFormHelpInfoTitle)}>
            <p className={classes.DialogFormTitleText}>
              Variance Log
                    </p>
          </div>
          <div className={classes.DialogFormContent} >
            {this.renderTableContainer()}
          </div>


        </DialogContent>
        <DialogActions>
          <Button onClick={this.closeDialog.bind(this)} color="primary"> Close </Button>
        </DialogActions>
      </Dialog>
    )
  }

}


export default VarianceLogDialog



// WEBPACK FOOTER //
// ./src/components/Dialogs/VarianceLogDialog.tsx